// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IAssociateSchedulesHttpResponse, ICourseSchedulingAssociationHttpResponse } from 'app_types/admin/courseScheduling/courseSchedulingAssociationTypes'
// @end

class CourseSchedulingAssociationService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async list(courseSchedulingId: string, params: any = {}) {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingAssociationHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/course-scheduling-association/${courseSchedulingId}/list`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }


  associateSchedules = async (courseSchedulingId: string, params: any) => {
    this.refreshAuthToken()

    let responseData: IAssociateSchedulesHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/course-scheduling-association/${courseSchedulingId}/associate-schedules`,
      auth_token: this.token,
      params: {...params},
    }

    responseData = await this.Http.send(queryData)

    return responseData
  }
}

export default CourseSchedulingAssociationService
